import React, { useMemo } from 'react';
import classNames from 'classnames';
import { FieldRenderProps } from 'react-final-form';
import ListingCreationSelect, {
  ListingCreationSelectProps,
} from '../ListingCreationSelect/ListingCreationSelect.component';
import FieldWrapper from 'components/FieldWrapper';
import { FieldWrapperProps } from 'components/FieldWrapper/FieldWrapper.component';

import './ListingCreationSelectField.styles.scss';

type ListingCreationSelectFieldProps = ListingCreationSelectProps<
  string | string[]
> &
  FieldWrapperProps &
  FieldRenderProps<string | string[], HTMLElement>;

const ListingCreationSelectField: React.FC<ListingCreationSelectFieldProps> = (
  props,
) => {
  const {
    className,
    input,
    meta: { touched, error },
    ...rest
  } = props;

  const hasError = useMemo(() => touched && error, [error, touched]);

  const classes = classNames('listing-creation-select-field', className);

  return (
    <FieldWrapper
      className={classes}
      hasError={hasError}
      error={error}
      {...rest}
    >
      <ListingCreationSelect {...rest} {...input} />
    </FieldWrapper>
  );
};

export default ListingCreationSelectField;
